import React from 'react';

import { useTranslation } from 'react-i18next';
import { SwiperSlide } from 'swiper/react';

import { useQuerySinglePromotion } from '@hooks/api/promotions/use-query-single-promotion';

import { PromotionDate } from '@components/promotion-date';
import { Slider } from '@components/slider';

import { MainWinnerCard } from './components/main-winner-card';
import { PrizeCard } from './components/prize-card';
import { SingleWinnerCard } from './components/single-winner-card';
import { WinnerTable } from './components/winner-table';
import * as Styled from './promotion-completed.styled';

type OwnProps = {
	id: string;
};

const PromotionCompleted: React.FC<OwnProps> = ({ id }) => {
	const { t } = useTranslation('main');
	const { data: promo } = useQuerySinglePromotion(id, 10, 1);

	return (
		<Styled.Wrapper>
			{promo && (
				<>
					<Styled.CompletedRow>
						<Styled.EndedChip>{t('ended_status')}</Styled.EndedChip>
						<PromotionDate isEnded start_date={promo.start_date} end_date={promo.end_date} />
					</Styled.CompletedRow>
					<Styled.Title>{promo.name}</Styled.Title>
					<Styled.Subtitle>{promo.description}</Styled.Subtitle>
					{promo.multiple_prize ? (
						<>
							<Styled.SliderWrapper>
								<Slider
									spaceBetween='16px'
									pagination={false}
									breakpoints={{
										998: {
											slidesPerView: 3
										},
										700: {
											slidesPerView: 2
										},
										0: {
											slidesPerView: 1
										}
									}}
								>
									{promo.prizes &&
										promo.prizes.map((prize, index) => (
											<SwiperSlide virtualIndex={index} key={index}>
												<PrizeCard prize={prize} />
											</SwiperSlide>
										))}
								</Slider>
							</Styled.SliderWrapper>
							{promo.winners && <WinnerTable isAll winnerUser={promo.current_user_winner} winners={promo.winners} />}
						</>
					) : (
						<>
							{promo.winners &&
								(promo.winners.length === 1 ? (
									<SingleWinnerCard winner={promo.winners[0]} />
								) : (
									<Styled.MainWinnerGrid>
										{promo.winners.slice(0, 3).map((winner, index) => (
											<MainWinnerCard winner={winner} key={index} />
										))}
									</Styled.MainWinnerGrid>
								))}
						</>
					)}
					{promo.winners && promo.winners.length > 3 && <WinnerTable winners={promo.winners} />}
				</>
			)}
		</Styled.Wrapper>
	);
};

export default PromotionCompleted;
